import { useSelector } from "react-redux";
import { selectShouldUseSideNav } from "../../app/dataServiceFeatureFlagsSlice";

/**
 * Custom hook to manage the side navigation feature flag
 * @returns Whether the side navigation is enabled
 */
export const useSideNavFeatureFlag = (): boolean => {
    return useSelector(selectShouldUseSideNav);
};
